"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signProfileContent = exports.signCompanyContent = exports.getProfileUploadUrl = exports.getCompanyUploadUrl = void 0;

/**
 * Generate signed cookie content
 *
 * @type {string}
 */
var signProfileContent = "\n  query {\n    signProfileContent {\n      cfPolicy\n      cfSignature\n      cfKeyPairId\n      cfExpires\n    }\n  }\n";
/**
 * Generate signed cookie content
 *
 * @type {string}
 */

exports.signProfileContent = signProfileContent;
var signCompanyContent = "\n  query {\n    signCompanyContent {\n      cfPolicy\n      cfSignature\n      cfKeyPairId\n      cfExpires\n    }\n  }\n"; // TODO create singular query in backend

exports.signCompanyContent = signCompanyContent;
var getProfileUploadUrl = "query ($contentType: String!) {\n  getMe {\n    profileUploadUrl(contentType: $contentType) {\n      url,\n      expires\n    }\n  }\n}";
exports.getProfileUploadUrl = getProfileUploadUrl;
var getCompanyUploadUrl = "query ($key: String!, $contentType: String!) {\n  getCompanyUploadUrl(key: $key, contentType: $contentType) {\n    url,\n    expires\n  }\n}";
exports.getCompanyUploadUrl = getCompanyUploadUrl;